export enum Theme {
  Default,
  MG,
}

export enum Language {
  English = "english",
  Hindi = "hindi",
}
